import { apiToken, campaignUrl, CampaignByIdUrl } from "../config";

// get all campaigns start
export const getAllCampaigns = async ({ page, limit, orderBy, orderDirection } = {}) => {
  try {
    const url = new URL(campaignUrl);
    const params = new URLSearchParams();

    if (page !== undefined) params.append('page', page);
    if (limit !== undefined) params.append('limit', limit);
    if (orderBy) params.append('orderBy', orderBy);
    if (orderDirection) params.append('orderDirection', orderDirection);

    if (params.toString()) {
      url.search = params.toString();
    }

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
    });

    const res = await response.json();
    if (!response.ok) {
      throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    }
    return res;
  } catch (e) {
    console.error("Error fetching campaigns:", e);
    throw e;
  }
};
// get all campaigns end

// create campaign start
export const createCampaign = async (formData) => {
  try {
    const response = await fetch(campaignUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
      body: JSON.stringify(formData),
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res;
  } catch (e) {
    console.error("Error creating campaign:", e);
    throw e;
  }
};
// create campaign end

// get campaign by id start
export const getCampaignById = async (id) => {
  try {
    const response = await fetch(CampaignByIdUrl(id), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res;
  } catch (e) {
    console.error("Error fetching campaign by ID:", e);
    throw e;
  }
};
// get campaign by id end

// update campaign start
export const updateCampaign = async (id, formData) => {
  try {
    const response = await fetch(CampaignByIdUrl(id), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
      body: JSON.stringify(formData),
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res;
  } catch (e) {
    console.error("Error updating campaign:", e);
    throw e;
  }
};
// update campaign end

// delete campaign start
export const deleteCampaign = async (id) => {
  try {
    const response = await fetch(CampaignByIdUrl(id), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res;
  } catch (e) {
    console.error("Error deleting campaign:", e);
    throw e;
  }
};
// delete campaign end

